/* eslint-disable import/prefer-default-export */
import type { SearchResult } from '../autocomplete.query'
import type { AutoCompleteRespTypeEnum } from '@src/endpoints/services/graphQueryMgr.service'

export const defaultState = {
  searchData: [] as string[],
  table: [] as SearchResult[],
  searchQuery: '' as string,
  isPending: false as boolean,
  autoCompleteRespType: null as AutoCompleteRespTypeEnum,
  sqlQueryUserUsage: '' as string,
  batchSize: 20 as number,
  hasNext: false as boolean,
  hasPrev: false as boolean
}

export type AutoCompleteState = Partial<typeof defaultState>
